const M = [
  {
    name: "bankCardManagement",
    zh: "银行卡管理",
    en: "Bank card management"
  },
  {
    name: "notBoundBankCardTips",
    zh: "您还未绑定银行卡，请绑定银行卡",
    en: "You have not bound bank card, bind bank card"
  },
  {
    name: "notAddedBankCard",
    zh: "您还未添加银行卡，",
    en: "You have not added a bank card,"
  },
  {
    name: "clickHereAdd",
    zh: "点此添加",
    en: "click here to add"
  },
  {
    name: "bindingBankCard",
    zh: "绑定银行卡",
    en: "Binding bank card"
  },
  {
    name: "editBankCard",
    zh: "编辑银行卡",
    en: "Edit bank card"
  },
  {
    name: "selectBelonging",
    zh: "请选择归属地",
    en: "Select location"
  },
  {
    name: "belonging",
    zh: "归属地",
    en: "Location"
  },
  {
    name: "china",
    zh: "中国(CNY)",
    en: "China (CNY)"
  },
  {
    name: "philippines",
    zh: "菲律宾(PHP)",
    en: "Philippines (PHP)"
  },
  {
    name: "vietnam",
    zh: "越南(VND)",
    en: "Vietnam (VND)"
  },
  {
    name: "cardHolder",
    zh: "持卡人",
    en: "Bank card name"
  },
  {
    name: "enterCardHolder",
    zh: "请输入持卡人姓名",
    en: "Enter bank card name"
  },
  {
    name: "bankCardNumber",
    zh: "银行卡号",
    en: "Bank card number"
  },
  {
    name: "enterBankNumber",
    zh: "请输入银行卡号",
    en: "Enter bank card number"
  },
  {
    name: "openingBank",
    zh: "开户银行",
    en: "Bank branch"
  },
  {
    name: "enterAccountBank",
    zh: "请输入开户银行",
    en: "Enter Bank branch"
  },
  {
    name: "accountName",
    zh: "账户名",
    en: "Account name"
  },
  {
    name: "enterAccountName",
    zh: "请输入账户名",
    en: "Enter account name"
  },
  {
    name: "bankAccount",
    zh: "银行账号",
    en: "Bank card"
  },
  {
    name: "enterBankAccount",
    zh: "请输入银行账号",
    en: "Enter bank card"
  },
  {
    name: "branch",
    zh: "分行",
    en: "branches"
  },
  {
    name: "enterBranchAddress",
    zh: "请输入分行地址",
    en: "Enter branch address"
  },
  {
    name: "confirmBinding",
    zh: "确认绑定",
    en: "Confirm"
  },
  {
    name: "bankTips",
    zh: "信息加密处理仅用于银行验证",
    en: "Information encryption is only used for bank verification"
  },
  {
    name: "bindingBankCardSuccess",
    zh: "绑定银行卡成功",
    en: "Binding succeed"
  },
  {
    name: "editBankCardSuccess",
    zh: "编辑银行卡成功",
    en: "Edit succeed"
  }
];

export default M;
